'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.query = undefined;

var _history = require('./history');

var _history2 = _interopRequireDefault(_history);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var query = exports.query = function query(search) {
  if (search === undefined) {
    search = _history2.default.location.search;
  }
  var obj = {};
  var tuples = search.split('?').pop().split('&');
  tuples.forEach(function (param) {
    var tuple = param.split('=');
    if (tuple.length === 2) {
      obj[decodeURIComponent(tuple[0])] = decodeURIComponent(tuple[1]);
    }
  });
  return obj;
};


//////////////////
// WEBPACK FOOTER
// ./js/lib.js
// module id = 221
// module chunks = 177